import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useGetDisputesQuery } from '../disputeSlice';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { IResolveDispute } from '../../../utils/types';
import FormDispute from '../formDispute/formDispute';
import './ReviewDispute.scss';
import { transformDataDisputeForm } from '../data-adapter';

type Props = {
    disputeDialogEnable: boolean;
    disputesId: string[];
    employeeNo: number;
    empDailyResultId: number;
    monthlyMetricsData: any;
    setDisputeDialogEnable: React.Dispatch<React.SetStateAction<boolean>>;
};

const ReviewDispute = ({
    disputeDialogEnable,
    disputesId,
    employeeNo,
    empDailyResultId,
    monthlyMetricsData,
    setDisputeDialogEnable,
}: Props) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [disputes, setDisputes] = useState([] as IResolveDispute[]);

    const { data: disputesData } = useGetDisputesQuery(
        {
            disputeIds: disputesId,
        },
        { skip: disputesId.length <= 0 }
    );

    useEffect(() => {
        if (disputesData?.data?.length > 0) {
            const disputes: IResolveDispute[] = transformDataDisputeForm(
                disputesData.data,
                empDailyResultId,
                loggedEmpNum?.toString(),
                employeeNo?.toString()
            );

            setDisputes(disputes);
        }
    }, [disputesData]);

   

    return (
        <Dialog
            header="Review Dispute"
            visible={disputeDialogEnable}
            style={{ width: '50vw' }}
            className="p-fluid disputeModal"
            onHide={() => setDisputeDialogEnable(false)}
            data-testid="review-dispute-dialog"
        >
            {disputes.map((dispute, index) => (
                <React.Fragment key={dispute.disputeId}>
                    <FormDispute dispute={dispute} index={index} monthlyMetricsData={monthlyMetricsData} />
                </React.Fragment>
            ))}
        </Dialog>
    );
};

export default ReviewDispute;
